import { autoinject, transient, useView } from "aurelia-framework";
import { EntityValidationsService } from "../../../../../../client-validation-system/validations-service";
import { ValidationActivation, ValidationTypeEnum } from "../../../../../../client-validation-system/validations.models";
import { BaseRuleRiskSettingModel, RiskCategoryLevelEnum } from "../../../../../../models/rules/rules.models";
import { NotificationClientService, NotificationType } from "../../../../../../services/basics/notification-client.service";
import { RulesClientService } from "../../../../../../services/rules/rules-client.service";

@autoinject
@transient()
@useView('views/pages/modules/customers/steps/rules/rule-risk-configs.html')
export class RuleRiskConfigs {
    riskCategorySettings: BaseRuleRiskSettingModel[] = [];
    level: RiskCategoryLevelEnum;

    constructor(private rulesService: RulesClientService, private notificationClientService:NotificationClientService, private entityValidationsService:EntityValidationsService) {

    }

    async activate(model: { id: number, level: RiskCategoryLevelEnum }) {
        try {
            this.level = model.level;
            this.riskCategorySettings = await this.rulesService.getRiskCategorySettings(model.level, model.id);
        } catch (e) {
            console.log(e);
        }
    }

    getValidator(item:BaseRuleRiskSettingModel) {

        const rulesHolder = {
            activation: ValidationActivation.Always,
            entityName: "Risk Rule",
            isCollection: false,
            nestedRulesHolder: [],
            rules: [{
                errorMessage: "Low Score must be greater than or equal to 1",
                parameters: JSON.stringify({ minimum: 1 }), property: "lowScore",
                validationType: ValidationTypeEnum.NumericRange
            },{
                errorMessage: `Medium Score must be greater than or equal to ${ (item.lowScore ? item.lowScore : 0) + 1}`,
                parameters: JSON.stringify({ minimum: (item.lowScore ? item.lowScore : 0) + 1}), property: "mediumScore",
                validationType: ValidationTypeEnum.NumericRange
            },{
                errorMessage: `High Score must be greater than or equal to ${ (item.mediumScore?item.mediumScore : item.lowScore?item.lowScore : 0)+1} and smaller or equal to 100`,
                parameters: JSON.stringify({ minimum: (item.mediumScore?item.mediumScore : item.lowScore?item.lowScore : 0) +1, maximum:100}), property: "highScore",
                validationType: ValidationTypeEnum.NumericRange
            }]
        };

        return this.entityValidationsService.getValidator(item, rulesHolder);
    }
    async save() {
        try {
            for(const score of this.riskCategorySettings){

                const validator = this.getValidator(score);
                const isValid = await validator.validate();
                if(!isValid.valid) return;
            }

            await this.rulesService.saveRiskCategorySettings(this.level, this.riskCategorySettings);
            this.notificationClientService.show("Save rule risk settings", "Saved successfully", NotificationType.Success);
        } catch (e) {
            this.notificationClientService.show("Save rule risk settings", "Failed to save", NotificationType.Error);
            console.log(e);
        }
    }
}
